import { useState } from "react"
import { apiClient } from "../config/api"

function NewsletterSubscription() {
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(false)
  const [messageType, setMessageType] = useState("") // 'success' or 'error'

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return regex.test(email)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    // Clear previous messages
    setMessage("")
    setMessageType("")

    // Validate email
    if (!validateEmail(email)) {
      setMessage("Please enter a valid email address")
      setMessageType("error")
      return
    }

    setLoading(true)
    try {
      // Add default preferences
      const payload = {
        email,
        preferences: {
          frequency: 'weekly',
          categories: []
        }
      }

      const response = await apiClient.post("/newsletter/subscribe", payload)
      setMessage(response.data.message)
      setMessageType("success")
      if (!response.data.requiresVerification) {
        setEmail("")
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "An error occurred. Please try again."
      setMessage(errorMessage)
      setMessageType("error")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-lg shadow-md">
      <h3 className="text-xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
        Subscribe to our Newsletter
      </h3>
      <p className="text-gray-600 dark:text-gray-400 mb-4">
        Get the latest updates and articles delivered straight to your inbox.
      </p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="relative">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:placeholder-gray-400"
            required
            disabled={loading}
          />
        </div>
        <button 
          type="submit" 
          disabled={loading}
          className={`w-full px-4 py-2 rounded-lg text-white font-medium transition-colors duration-200
            ${loading 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-700'
            }`}
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Subscribing...
            </span>
          ) : (
            'Subscribe'
          )}
        </button>
      </form>
      {message && (
        <div className={`mt-4 p-3 rounded-lg text-sm ${
          messageType === 'success' 
            ? 'bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-200' 
            : 'bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-200'
        }`}>
          {message}
        </div>
      )}
    </div>
  )
}

export default NewsletterSubscription

